import { IUserReaction } from '@gem/models/reactionsModel';
import { loadLottieFile } from '@gem/modules/rlottie';

import { animationsCache } from 'APP/cache/animations';
import { getUserReactions } from 'APP/model/reactions/reactionsModel';
import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

const FILE_LOADED_COUNT = 3;

const loadReactionsPack = async (updateTs: number): Promise<IUserReaction[]> => {
  try {
    const reactions = await getUserReactions();

    if (reactions.length === 0) {
      return [];
    }

    Entities.reactionsStore.setReactions(reactions);
    storage.reactionsPack.setReactionPack({
      lastUpdateTime: updateTs,
      pack: reactions,
    });

    return reactions;
  } catch {
    return [];
  }
};

const loadReactions = async (reactions: IUserReaction[]): Promise<void> => {
  if (reactions.length === 0) {
    return;
  }

  const loadPromises: Promise<Record<string, any> | null>[] = [];
  reactions.slice(0, FILE_LOADED_COUNT).forEach((reaction) => {
    loadPromises.push(loadLottieFile(reaction.animationUrl, animationsCache));
  });

  await Promise.all(loadPromises);
  return await loadReactions(reactions.slice(FILE_LOADED_COUNT));
};

export async function handleReactions({ updateTs }: { updateTs: number }): Promise<void> {
  const data = storage.reactionsPack.getReactionPack();

  if (!data || !data.lastUpdateTime || updateTs > data.lastUpdateTime) {
    const reactions = await loadReactionsPack(updateTs);
    loadReactions(reactions);
  } else {
    Entities.reactionsStore.setReactions(data.pack);
  }
}
